const colorSwatches = [
   {
    color: "Black",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_black.jpg",
    imageName: "Black Chenille",
  },
   {
    color: "Cream",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_cream_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_cream_1.jpg",
    imageName: "Cream Chenille",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_grey.jpg",
    imageName: "Grey Chenille",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_mink.jpg",
    imageName: "Mink Chenille",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_purple.jpg",
    imageName: "Purple Chenille",
  },
   {
    color: "Red",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_red.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_red.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_red.jpg",
    imageName: "Red Chenille",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_silver.jpg",
    imageName: "Silver Chenille",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Swiss Chenille",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_teal.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_fold_teal.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Chenille_flat_teal.jpg",
    imageName: "Teal Chenille",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_Fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Blue.jpg",
    imageName: "Blue Coniston",
  },
   {
    color: "Red",
    tone: "Dark",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_clargt.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_claret.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_clargt.jpg",
    imageName: "Claret Coniston",
  },
   {
    color: "Cream",
    tone: "Light",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Cream.jpg",
    imageName: "Cream Coniston",
  },
   {
    color: "Emerald",
    tone: "Dark",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Emerald_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_Emerald.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Emerald_1.jpg",
    imageName: "Emerald Coniston",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_Grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_Grey.jpg",
    imageName: "Grey Coniston",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_pink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_pink.jpg",
    imageName: "Pink Coniston",
  },
   {
    color: "Silver/Grey/White",
    tone: "Mix Tones",
    material: "House Coniston Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Coniston_flat_silver.jpg",
    imageName: "Silver Coniston",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_black.jpg",
    imageName: "Black Crushed Velvet",
  },
   {
    color: "Cream",
    tone: "Dark",
    material: "Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_cream.jpg",
    imageName: "Cream Crushed Velvet",
  },
   {
    color: "Turmeric",
    tone: "Mix Tones",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_gold.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_gold.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_gold.jpg",
    imageName: "Gold Crushed Velvet",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_mink.jpg",
    imageName: "Mink Crushed Velvet",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_pink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_pink.jpg",
    imageName: "Pink Crushed Velvet",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_Lilac_Purple.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_purple.jpg",
    imageName: "Purple Crushed Velvet",
  },
   {
    color: "Red",
    tone: "Mix Tones",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_red.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_red.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_red.jpg",
    imageName: "Red Crushed Velvet",
  },
   {
    color: "Silver/Grey/White",
    tone: "Mix Tones",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_silver.jpg",
    imageName: "Silver Crushed Velvet",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Glitz Crushed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_white.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_fold_white.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Crush_velvet_flat_white.jpg",
    imageName: "White Crushed Velvet",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_black.jpg",
    imageName: "Black Leather",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_blue.jpg",
    imageName: "Blue Leather",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_brown.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_brown.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_brown.jpg",
    imageName: "Brown Leather",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_grey.jpg",
    imageName: "Grey Leather",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_pink_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_pink_1.jpg",
    imageName: "Pink Leather",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_rustic_brown.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_rustic_brown.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_rustic_brown.jpg",
    imageName: "Rustic Brown Leather",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_silver.jpg",
    imageName: "Silver Leather",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "Faux Leather",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_white.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_fold_white.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Leather_flat_white.jpg",
    imageName: "White Leather",
  },
   {
    color: "Beige",
    tone: "Mix Tones",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_beige.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_beige.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_beige.jpg",
    imageName: "Beige Linen",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_Black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_black.jpg",
    imageName: "Black Linen",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_blue.jpg",
    imageName: "Blue Linen",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_Grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_grey.jpg",
    imageName: "Grey Linen",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_mink.jpg",
    imageName: "Mink Linen",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_purple.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_purple.jpg",
    imageName: "Purple Linen",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Egyptian Linen",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Linen_flat_silver.jpg",
    imageName: "Silver Linen",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_black.jpg",
    imageName: "Black Naple",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_blue.jpg",
    imageName: "Blue Naple",
  },
   {
    color: "Cream",
    tone: "Light",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_cream.jpg",
    imageName: "Cream Naple",
  },
   {
    color: "Green",
    tone: "Dark",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_green.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_Green.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_green.jpg",
    imageName: "Green Naple",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_lilac_2.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_lilac.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_lilac_2.jpg",
    imageName: "Lilac Naple",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_Mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_mink.jpg",
    imageName: "Mink Naple",
  },
   {
    color: "Orange",
    tone: "Light",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_orange.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_Orange.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_orange.jpg",
    imageName: "Orange Naple",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_pink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_pink.jpg",
    imageName: "Pink Naple",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_Purple.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_purple.jpg",
    imageName: "Purple Naple",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "Plain Naples Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Naple_flat_silver.jpg",
    imageName: "Silver Naple",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_black.jpg",
    imageName: "Black Plush",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_blue.jpg",
    imageName: "Blue Plush",
  },
   {
    color: "Red",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_burgundy_2.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_burgundy.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_burgundy_2.jpg",
    imageName: "Burgundy Plush",
  },
   {
    color: "Cream",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_cream.jpg",
    imageName: "Cream Plush",
  },
   {
    color: "Green",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_duck_egg.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_duck_egg.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_duck_egg.jpg",
    imageName: "Duckegg Plush",
  },
   {
    color: "Green",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_emerald.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Emerald.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_emerald.jpg",
    imageName: "Emerald Plush",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_grey.jpg",
    imageName: "Grey Plush",
  },
   {
    color: "Blue",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_ice_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Ice_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_ice_blue.jpg",
    imageName: "Ice Blue Plush",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_mink_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_mink_1.jpg",
    imageName: "Mink Plush",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_pink_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_pink_1.jpg",
    imageName: "Pink Plush",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_Silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_silver.jpg",
    imageName: "Sivler Plush",
  },
   {
    color: "Turmeric",
    tone: "Mix Tones",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_turmik.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_turmeric.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_turmik.jpg",
    imageName: "Turmeric Plush",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "French Plush Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_white.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_fold_white.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Plush_flat_white.jpg",
    imageName: "White Plush",
  },
   {
    color: "Blue",
    tone: "Mix Tones",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Blue.jpg",
    imageName: "Blue Greek Mystic",
  },
   {
    color: "Cream",
    tone: "Light",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_Cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Cream.jpg",
    imageName: "Cream Greek Mystic",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Grey.jpg",
    imageName: "Grey Greek Mystic",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Mink.jpg",
    imageName: "Mink Greek Mystic",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Pink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Pink.jpg",
    imageName: "Pink Greek Mystic",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_purple_light.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Purple.jpg",
    imageName: "Purple Greek Mystic",
  },
   {
    color: "Silver/Grey/White",
    tone: "Mix Tones",
    material: "Greek Mystic Printed Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Greek_Mystic_flat_Silver.jpg",
    imageName: "Silver Greek Mystic",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_blue.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_blue.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_blue.jpg",
    imageName: "Blue Teddy",
  },
   {
    color: "Cream",
    tone: "Light",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_cream.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_cream.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_cream.jpg",
    imageName: "Cream Teddy",
  },
   {
    color: "Green",
    tone: "Dark",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_green.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_green.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_green.jpg",
    imageName: "Green Teddy",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_Grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_grey.jpg",
    imageName: "Grey Teddy",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_mink.jpg",
    imageName: "Mink Teddy",
  },
   {
    color: "Pink/Purple",
    tone: "Light",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_pink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_pink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_pink.jpg",
    imageName: "Pink Teddy",
  },
   {
    color: "Silver/Grey/White",
    tone: "Light",
    material: "British Bouclé Teddy",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_fold_Silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Teddy_flat_silver.jpg",
    imageName: "Silver Teddy",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Australian Wool",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_grey.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_fold_grey.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_grey.jpg",
    imageName: "Grey Wool",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Australian Wool",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_jade_1.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_fold_jade.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_jade_1.jpg",
    imageName: "Jade Wool",
  },
   {
    color: "Mink/Brown",
    tone: "Dark",
    material: "Australian Wool",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_fold_Mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_mink.jpg",
    imageName: "Mink Wool",
  },
   {
    color: "Pink/Purple",
    tone: "Dark",
    material: "Australian Wool",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_purple.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_fold_purple.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_purple.jpg",
    imageName: "Purple Wool",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Australian Wool",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Wool_flat_silver.jpg",
    imageName: "Silver Wool",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_Gunmetal.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_Gunmetal.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_Gunmetal.jpg",
    imageName: "Gunmetal Marble",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_mink.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_mink.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_mink.jpg",
    imageName: "Mink Marble",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_oatmeal.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_oatmeal.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_oatmeal.jpg",
    imageName: "Oatmeal Marble",
  },
   {
    color: "Blue",
    tone: "Dark",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_ocean.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_ocean.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_ocean.jpg",
    imageName: "Ocean Marble",
  },
   {
    color: "Blue",
    tone: "Light",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_peacock.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_peacock.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_peacock.jpg",
    imageName: "Peacock Marble",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_platinum.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_platinum.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_platinum.jpg",
    imageName: "Platinum Marble",
  },
   {
    color: "Mink/Brown",
    tone: "Mix Tones",
    material: "Marble Velvet",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_stone.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_fold_stone.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Marble_flat_stone.jpg",
    imageName: "Stone Marble",
  },
   {
    color: "Black",
    tone: "Dark",
    material: "Suede",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_flat_black.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_fold_black.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_flat_black.jpg",
    imageName: "Black Suede",
  },
   {
    color: "Silver/Grey/White",
    tone: "Dark",
    material: "Suede",
    carasouel: [
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_flat_silver.jpg",
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_fold_silver.jpg",
    ],
    image:
      "https://cdn.shopify.com/s/files/1/0518/2157/6345/t/40/assets/Swede_flat_silver.jpg",
    imageName: "Silver Suede",
  },
];
